import store from '@/store/store';
import { actions as _act } from '@/models/store.actions';
import { InstructionChapter } from '@/models/enums';
import { EventBus } from '@/helpers/event-bus';
import { isNativeApp } from '@/helpers/platform-helper';
import { isMobile } from 'mobile-device-detect';
import router from '@/router/router';

const instructionChapterToHashMap = {
  [InstructionChapter.LoginAndRegistration]: '#tabone',
  [InstructionChapter.MainWindow]: '#tabfive',
  [InstructionChapter.PersonalCabinet]: '#tabseven',
  [InstructionChapter.OrganizationSettings]: '#tabeight',
  [InstructionChapter.NavigationPanel]: '#tabfourteen',
  [InstructionChapter.DocumentList]: '#tabsixteen',
  [InstructionChapter.DocumentView]: '#tabeighteen',
  [InstructionChapter.DocumentManagement]: '#tabnineteen',
  [InstructionChapter.Folders]: '#tabtwenty',
  [InstructionChapter.Tags]: '#tab21',
  [InstructionChapter.Instruments]: '#tab22',
  [InstructionChapter.WorkWithDocuments]: '#tab23',
  [InstructionChapter.CreatignDocument]: '#tab24',
  [InstructionChapter.WorkWithDocumentFiles]: '#tab25',
  [InstructionChapter.VerificationOfSignatures]: '#tab26',
  [InstructionChapter.LinkedDocuments]: '#tab27',
  [InstructionChapter.AgreeingOfTheDocument]: '#tab28',
  [InstructionChapter.SigningOfTheDocument]: '#tab29',
  [InstructionChapter.AcquaintingOfTheDocument]: '#tab30'
};

const routeToInstructionChapterMap = {
  'login': InstructionChapter.LoginAndRegistration,
  'registration': InstructionChapter.LoginAndRegistration,
  'home': InstructionChapter.MainWindow,
  'cabinet': InstructionChapter.PersonalCabinet,
  'organization': InstructionChapter.OrganizationSettings,
  // InstructionChapter.NavigationPanel
  'docs': InstructionChapter.DocumentList,
  'viewdoc': InstructionChapter.DocumentView,
  // InstructionChapter.DocumentManagement
  'filefolders': InstructionChapter.Folders,
  'folders': InstructionChapter.Tags,
  'utilities': InstructionChapter.Instruments,
  // InstructionChapter.WorkWithDocuments
  'documentAdd': InstructionChapter.CreatignDocument
  // InstructionChapter.WorkWithDocumentFiles
  // InstructionChapter.VerificationOfSignatures,
  // InstructionChapter.LinkedDocuments
  // InstructionChapter.AgreeingOfTheDocument
  // InstructionChapter.SigningOfTheDocument
  // InstructionChapter.AcquaintingOfTheDocument
};

let landingUrl: string | undefined;
let instructionsPath: string | undefined;
let defaultInstructionsPath: string = 'instructions/index.html';

async function initLandingUrl(): Promise<string | undefined> {
  if (typeof landingUrl === 'undefined') {
    await store.getters[_act.SETT_GET_CFG_WAITER];
    const appSettings = store.getters[_act.SETT_GET_APPSET];
    if (appSettings) {
      landingUrl = appSettings['landingPageBaseUrl'];
      instructionsPath = appSettings['landingPageInstructionsPath'];
    }
    landingUrl = landingUrl || '';
    instructionsPath = instructionsPath || defaultInstructionsPath;
  }
  return landingUrl;
}

export async function showInstruction(
  openInNewWindow: boolean = false,
  chapter: InstructionChapter | undefined = undefined
): Promise<void> {
  await initLandingUrl();
  if (landingUrl) {
    let chapterHash = '';
    if (chapter !== undefined) {
      chapterHash = instructionChapterToHashMap[chapter];
    } else if (router.currentRoute) {
      let c = routeToInstructionChapterMap[router.currentRoute.name || ''];
      if (c === undefined) {
        for (let r of router.currentRoute.matched) {
          c = routeToInstructionChapterMap[r.name || ''];
          if (c) {
            break;
          }
        }
      }
      if (c !== undefined) {
        chapterHash = instructionChapterToHashMap[c];
      }
    }

    let instructionUrl = `${landingUrl}/${instructionsPath}?v=${store.getters[_act.SETT_GET_CURENTVERSIONGET]}`;
    if (openInNewWindow || isMobile || isNativeApp()) {
      instructionUrl = `${instructionUrl}${chapterHash}`;
      window.open(instructionUrl, '_blank');
    } else {
      instructionUrl = `${instructionUrl}&mode=1${chapterHash}`;
      EventBus.$emit('show-instruction', { instructionUrl });
    }
  }
}
